import { baseApi } from "../baseApi";
import { flattenQueryParams } from "@/utils/requestUtils";

const chatTag = "Chat";

type SessionStatus = "active" | "inactive" | "both";
type ChatType = "chat" | "conference" | "group" | "a2a" | "any";

export type GetChatRoomsParams = {
  personal?: boolean;
  "chat-type"?: ChatType;
  "session-status"?: SessionStatus;
};

export type GetMessagesParams = {
  sessionKey: string;
  page?: number;
  limit?: number;
};

export type GetParticipantsParams = {
  sessionKey: string;
};

const chatApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getChatRooms: builder.query<any, GetChatRoomsParams | void>({
      query: (params) => {
        const queryString = params
          ? `?${new URLSearchParams(flattenQueryParams(params)).toString()}`
          : "";
        return `/chat/rooms${queryString}`;
      },
      providesTags: [chatTag],
    }),

    getChatRoomParticipants: builder.query<any, GetParticipantsParams>({
      query: ({ sessionKey }) => {
        console.log("session keyyy", sessionKey)
        const safeKey = encodeURIComponent(sessionKey);
        return `/chat/rooms/${safeKey}/participants`;
      },
      providesTags: (result, error, { sessionKey }) => [{ type: chatTag, id: `p:${sessionKey}` }],
    }),
getChatRoomMessages: builder.query<any, GetMessagesParams>({
  query: ({ sessionKey, page = 1, limit = 20 }) => {
    const safeKey = encodeURIComponent(sessionKey);
    console.log("page, limit", page, limit)
    return {
      url: `/chat/rooms/${safeKey}/messages`,
      params: { page, limit }, // RTK Query bunu otomatik stringe çevirir
    };
  },
  providesTags: (result, error, { sessionKey }) => [{ type: chatTag, id: `m:${sessionKey}` }],
}),
  }),
});

export const {
  useGetChatRoomsQuery,
  useGetChatRoomParticipantsQuery,
  useGetChatRoomMessagesQuery,
  useLazyGetChatRoomMessagesQuery
} = chatApi;

export default chatApi;
